import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLineModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MaterialComponentsModule } from '../../shared/material.module';
import { FrozenStructureModalComponent } from './frozen-structure-modal/frozen-structure.modal';
import { SettingsUsersSyncComponent } from './users-sync.component';
import { SettingsUsersSyncDetailsComponent } from './sync-details/sync-details.component';
import { UsersSyncErrorDialogComponent } from './users-sync-error-dialog/users-sync-error.dialog';
import { PaginationModule } from 'src/app/shared/components/pagination/pagination.module';
import { DateRangePickerModule } from 'src/app/shared/components/date-range-picker/date-range.picker.module';
import { ListSearchModule } from 'src/app/shared/components/list-search/list-search.module';
import { UsersTabsModule } from 'src/app/shared/components/users-tabs/users-tabs.module';
import { StatusTagModule } from 'src/app/shared/components/layout/status-tag/status-tag.component.module';
import { UsersService } from '../users.service';
import { IonicModule } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { Evaluation360Service } from 'src/app/360-evaluation/360-evaluation.service';
import { ManagerEvaluationService } from 'src/app/manager-evaluation/manager-evaluation.service';
import { SelfEvaluationService } from 'src/app/self-evaluation/self-evaluation.service';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        SettingsUsersSyncComponent,
        SettingsUsersSyncDetailsComponent,
        UsersSyncErrorDialogComponent,
        FrozenStructureModalComponent
    ],
    imports: [
        CommonModule,
        MaterialComponentsModule,
        RouterModule,
        PaginationModule,
        DateRangePickerModule,
        ListSearchModule,
        UsersTabsModule,
        StatusTagModule,
        IonicModule,
        PipesModule,
        FormsModule,
        NgxMatTimepickerModule,
        NgxMatDatetimePickerModule,
        MatDatepickerModule,
        NgxMatNativeDateModule,
        MatLineModule,
        MatIconModule,
        MatDialogModule,
    ],
    providers: [
        UsersService,
        Evaluation360Service,
        ManagerEvaluationService,
        SelfEvaluationService,
        TranslationService
    ]
})
export class SettingsUsersSyncModule {
}
